import _ from 'lodash';

import { compareBySearchValue } from 'utils/searchItems';

const filterDynamicFields = (dynamicFieldsSchema, search) => {
  return (dynamicFieldsSchema ?? []).filter(category => {
    if (compareBySearchValue(category.title, search)) {
      return true;
    }

    category.fields = category.fields?.filter(c => compareBySearchValue(c.title, search));
    category.categories = filterDynamicFields(category.categories, search);

    return category.fields?.length > 0 || category.categories?.length > 0;
  });
};

export const getFilteredDynamicFieldsSchema = (dynamicFieldsSchema, search) => {
  if (!search) {
    return dynamicFieldsSchema;
  }

  return filterDynamicFields(_.cloneDeep(dynamicFieldsSchema), search);
};
